import { useNavigate } from 'react-router-dom';
import { useResetPasswordMutation } from 'shared/hooks/queries/use-reset-password-mutation';
import { Paths } from 'shared/routes';

export const useResetPassword = () => {
  const navigate = useNavigate();
  const { mutateAsync, error, reset, isPending, isSuccess } =
    useResetPasswordMutation();

  const resetPassword = async ({
    password,
    code,
  }: {
    password: string;
    code: string;
  }) => {
    await mutateAsync({ password, code });
    navigate(Paths.Home);
  };

  return {
    resetPassword,
    error,
    isLoading: isPending,
    isSuccess,
    reset,
  };
};
